import script from "./cropper-component.vue?vue&type=script&setup=true&lang=js"
export * from "./cropper-component.vue?vue&type=script&setup=true&lang=js"

import "./cropper-component.vue?vue&type=style&index=0&id=b6ab4ad6&lang=scss&scoped=true"

import exportComponent from "/Users/wen/projects/chun-qiu-museum/node_modules/_vue-loader@17.0.0@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6ab4ad6"]])

export default __exports__